import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import Tr from '../../../../../components/common-table/components/Tr';
import Td from '../../../../../components/common-table/components/Td';
import TdCheckbox from '../../../../../components/common-table/components/TdCheckbox';
import LinkCell from './LinkCell';
import { selectOneDataset } from '../../../../../redux/create-sonar/createSonarReducer';
import CommonIconButton from '../../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../../icons';

import scss from '../SonarCreationForm.module.scss';

const DatasetTableItem = ({ item, onEdit, onDelete }) => {
  const { count, brandCompany, socials, isSelected, inFocus, id } = item;
  const dispatch = useDispatch();
  const { t } = useTranslation('projects');

  const { LINKEDIN, TRUSTPILOT, INSTAGRAM, YOUTUBE, FACEBOOK, TIKTOK, TWITTER } = socials;

  const handleSelectRow = useCallback(() => {
    dispatch(selectOneDataset(id));
  }, [dispatch, id]);

  const handleEdit = useCallback(() => {
    onEdit(item);
  }, [onEdit, item]);

  const handleDelete = useCallback(() => {
    onDelete(item);
  }, [onDelete, item]);

  return (
    <Tr>
      <TdCheckbox selected={isSelected} onSelect={handleSelectRow} />
      <Td extraClasses={scss.cellRank}>{count}</Td>
      <Td isLeft extraClasses={clsx(scss.companyNameCell, inFocus && scss.companyNameCellFocus)}>
        {brandCompany}
      </Td>
      <LinkCell links={FACEBOOK} />
      <LinkCell links={INSTAGRAM} />
      <LinkCell links={YOUTUBE} />
      {/* <LinkCell links={TRUSTPILOT} /> */}
      <LinkCell links={TWITTER} />
      <LinkCell links={TIKTOK} />
      {/* <LinkCell links={LINKEDIN} /> */}
      <Td extraClasses={scss.actionCell}>
        <CommonIconButton icon={ICONS.Edit} tooltip={t('edit')} onClick={handleEdit} />
        <CommonIconButton icon={ICONS.Delete} tooltip={t('delete')} onClick={handleDelete} />
      </Td>
    </Tr>
  );
};

export default DatasetTableItem;
